<template>
  <div class="basic-block block-uranaitv-desc-2" :style="styles">
    <div class="block-uranaitv-desc-2__inner">
      <div class="block-uranaitv-desc-2__lead">
        <img :src="`${path}lead2.png`" alt="">
      </div>
      <div class="block-uranaitv-desc-2__point1">
        <h3 class="block-uranaitv-desc-2__headline">1.使い方は簡単！</h3>
        <img :src="`${path}point1_lead.png`" alt="" class="lead">
        <div class="box">
          <img :src="`${path}point1_text.png`" alt="" class="text">
          <div class="videoWrap">
            <video
              src="https://uranaitv-store-imglogic.s3.ap-northeast-1.amazonaws.com/reco/movie/coco_LP_low.mp4"
              autoplay loop muted playsinline
            ></video>
          </div>
        </div>
        <lp-base-button
          label="月額会員になる"
          design="fill"
          :color-scheme="colorScheme"
          class="block-uranaitv-desc-2__point-btn"
          @clicked="onSubscrBtnClick('HowToUse')"
        />
      </div>
      <div class="block-uranaitv-desc-2__point2">
        <h3 class="block-uranaitv-desc-2__headline">2. 登録は簡単2ステップ</h3>
        <img :src="`${path}point2.png`" alt="" class="lead">
        <lp-base-button
          label="登録してみる"
          design="fill"
          :color-scheme="colorScheme"
          class="block-uranaitv-desc-2__point-btn"
          @clicked="onSubscrBtnClick('RegistStep')"
        />
      </div>
      <div class="block-uranaitv-desc-2__point3">
        <h3 class="block-uranaitv-desc-2__headline">3. 本格占いや毎日の占い<br>今年の運勢も充実</h3>
        <img :src="`${path}point3_1.png`" alt="">
        <div class="box">
          <img :src="`${path}point3_2.png`" alt="">
          <div class="videoWrap">
            <video
              src="https://s3-ap-northeast-1.amazonaws.com/uranaitv-town-dev/lp/video_letter/fast/seimei.mp4"
              autoplay loop muted playsinline
            ></video>
          </div>
        </div>
        <div class="block-uranaitv-desc-2__counselors">
          <img :src="`${path}point3_counselors.jpg`" alt="">
        </div>
        <img :src="`${path}point3_lead.png`" alt="" class="lead">
        <lp-base-button
          label="登録してみる"
          design="fill"
          :color-scheme="colorScheme"
          class="block-uranaitv-desc-2__point-btn"
          @clicked="onSubscrBtnClick('LotsOfMenus')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'BlockUranaiTvDesc2',
  components: {
    LpBaseButton,
  },
  data() {
    return {
      path: '/static/img/recommend/lp/kanoucoco/uTVdesc2/'
    }
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    previewResultList: {
      type: Array,
      default: null,
    },
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
  },
  methods: {
    onSubscrBtnClick(val){
      const payload = {
        link: 'subsc',
        param: {
          'event_category': `LP${this.lpId}-subsc-button`,
          'event_label': `${val}`
        }
      }
      this.$emit('link', payload)
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-uranaitv-desc-2 {
  background: url('/static/img/recommend/lp/kanoucoco/deco_wave2.png') no-repeat 50% -56px/100% 112px #FBF8F1;
  padding: 0 0 80px;
  img {
    display: block;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  &__inner {
    padding: 0 20px;
    max-width: 460px;
    margin: auto;
  }
  &__headline {
    font-weight: bold;
    font-size: unquote('min(6.93vw, 34px)');
    line-height: 1.385;
    text-align: center;
    color: #fff;
    background: #FF9B96;
    min-width: 252px;
    display: table;
    padding: 0.3% 3.88%;
    margin: 23.88% auto 11.94%;
  }
  &__lead {
    margin: 0 -20px;
  }
  &__point1 {
    .lead {
      margin: 0 auto 60px;
      width: 95.522%;
    }
    .box {
      border: 1px solid #FF9B96;
      border-radius: 10px;
      padding: 7.164% 0 8.955%;
      margin: 0 auto 11.94%;
    }
    .text {
      margin: 0 auto 16px;
      width: 65.671%;
    }
    .videoWrap {
      // width: 55.591%;
      // max-width: 300px;
      margin: auto 60px;
    }
    video {
      margin: auto;
      width: 100%;
      max-width: 313px;
      display: block;
    }
    .block-uranaitv-desc-2__headline { margin-top: 18%; }
  }
  &__point2 {
    .lead {
      width: 81.194%;
    }
  }
  &__point3 {
    .box {
      position: relative;
      margin: 7.16% auto 23.88%;
    }
    .videoWrap {
      width: 40.298%;
      position: absolute;
      top: 16%;
      left: 6.268%;
      z-index: 1;
    }
    video {
      margin: auto;
      width: 100%;
    }
    .block-uranaitv-desc-2__point-btn {
      margin-top: 60px;
    }
    .lead {
      width: 77.612%;
    }
  }
  &__counselors {
    margin: 0 -20px 60px;
  }
  &__point-btn {
    width: 80.59%;
    max-width: 340px;
    margin: 40px auto 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kanoucoco/blocks/BlockUranaiTvDesc2.vue